import React, { useEffect, useState } from 'react'
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { prefix } from '../../../utils/index_tagging_tool'

import excel_template from '../../resources/test_seo_rules_upload.xlsx'
import { Link } from 'react-router-dom'
import FileInput from '../../../components/molecules/FileInput'
import { useFileUpload } from '../../../hooks'

// Qui sa Gabri
export default function BulkExcelUpload({ dim, loader }) {
  const [file, setFile] = useState()
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState('')
  const [show, setShow] = useState(false)
  const { upload, loading } = useFileUpload()

  const toggle = () => {
    setShow(!show)
    setMessage('')
    setStatus('')
  };

  const closeBtn = (
    <button className="close" onClick={toggle} type="button">
      &times;
    </button>
  );


  const handleUpload = async (e) => {
    if (file === undefined) {
      setMessage('Selezionare un file')
      return
    }

    var formData = new FormData()
    formData.append('file', file)
    setMessage('')

    try {
      const data = await upload('post', `${prefix}rule-file-upload/${dim}/`, formData)
      setStatus(200)
      setMessage(data)
    } catch (err) {
      // The hook already notified the user.
      const errorMessage = err.response?.data || err.message
      setMessage(errorMessage)
    }
  }

  useEffect(() => {
    if (status === 200) {
      window.location.reload()
    }
  }, [status])

  return (
    <>
      <button
        type="button"
        className="btn btn-info mr-2"
        onClick={() => setShow(true)}
        disabled={loader}
      >
        <i className="fas fa-file-upload"></i> Upload Excel
      </button>
      <Modal
        isOpen={show}
        size="sm"
        centered={true}
      >
        <ModalHeader tag="h3" className="border align-items-center" close={closeBtn}>
            Excel Upload
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <FileInput
                onFileChange={setFile}
                accept=".xlsx, .xls"
                required={true}
              />
            </Col>
            {loading && <Col><div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div></Col>}
          </Row>
          <Row className="justify-content-center pt-2">
            <Col>
              <label>{message}</label>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="border justify-content-center">
          <button
            type="button"
            className="btn btn-info mr-2"
            onClick={handleUpload}
          >
            Upload
          </button>
          <Button className="btn mr-2" variant="secondary">
            <Link to={excel_template} target="_blank" download>
              File di esempio
            </Link>
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}
